import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AboutInternship.css';

const AboutInternship = () => {
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <div className={`about-container ${fadeIn ? 'fade-in' : ''}`}>
      <button
        onClick={() => navigate('/register')}
        className="back-button"
      >
        ← Back to Registration
      </button>

      <h1 className="about-heading">Machine Learning Internship & Training Program</h1>
      <p className="tagline">Organized by CVEY Solutions Pvt. Ltd.</p>

      <section className="about-section program-overview">
        <h2>Program Overview</h2>
        <p><strong>Mode:</strong> Virtual Training</p>
        <p><strong>Position:</strong> Machine Learning Trainee</p>
      </section>

      <section className="about-section">
        <h2>Benefits</h2>
        <ul className="benefits-list">
          <li>Internship Certificate</li>
          <li>Hands-on Practice with Machine Learning Technologies:</li>
          <ul className="sub-list">
            <li><strong>Programming:</strong> Python</li>
            <li><strong>Libraries:</strong> NumPy, Pandas, Matplotlib, Scikit-learn</li>
            <li><strong>ML Frameworks:</strong> TensorFlow / PyTorch Basics</li>
          </ul>
          <li>Work with Real-world Machine Learning Datasets</li>
          <li>Build and Train Machine Learning Models</li>
          <li>Develop Data Analysis and Visualization Skills</li>
          <li>Learn Model Evaluation and Optimization Techniques</li>
        </ul>
      </section>

      <section className="about-section">
        <h2>Training Curriculum</h2>
        <div className="curriculum-grid">
          <div>
            <h3 className="about-subheading">Phase 1: Python & Data Analysis</h3>
            <ul className="about-list">
              <li>Introduction to Python for Machine Learning</li>
              <li>Python Data Structures and Functions</li>
              <li>Data Analysis using NumPy and Pandas</li>
              <li>Data Visualization using Matplotlib and Seaborn</li>
            </ul>
          </div>

          <div>
            <h3 className="about-subheading">Phase 2: Machine Learning & Model Development</h3>
            <ul className="about-list">
              <li>Introduction to Machine Learning Concepts</li>
              <li>Supervised Learning Algorithms</li>
              <li>Model Training, Testing, and Evaluation</li>
              <li>Building End-to-End Machine Learning Projects</li>
              <li>Model Deployment Basics</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="about-section">
        <h2>Contact & Information</h2>
        <p>
          Website: <a href="https://cveysolutions.in" target="_blank" rel="noopener noreferrer" className="about-link">cveysolutions.in</a>
        </p>
        <p>
          Email: <a href="mailto:support@cveysolutions.in" className="about-link">support@cveysolutions.in</a>
        </p>
        <p>For more queries, reach out to our HR team via our website.</p>
      </section>

      <footer className="about-footer">
        © CVEY Solutions Pvt. Ltd. | All Rights Reserved
      </footer>
    </div>
  );
};

export default AboutInternship;